import React from "react";
import { getPublisherAvatarUrl } from "../../utils";
import {
  formatPostDate,
  getPlainExcerpt,
  getPostTypeLabel,
} from "./publicBlogUtils";
import {
  FeaturedContributorBadge,
  PublicBlogAuthorLink,
  PublicBlogAuthorRow,
  PublicBlogCardBody,
  PublicBlogCardExcerpt,
  PublicBlogCardGrid,
  PublicBlogCardMedia,
  PublicBlogCardMediaGradient,
  PublicBlogCardOverlayLink,
  PublicBlogCardRoot,
  PublicBlogCardTitle,
  PublicBlogMeta,
  PublicBlogMetaDate,
  PublicBlogTag,
  PublicBlogTags,
  PublicBlogTypePill,
} from "./PublicBlog.styles";

const typeIcon = (typeLabel) =>
  typeLabel === "Video" ? "play_circle" : "menu_book";

const PublicBlogCard = ({ post }) => {
  const typeLabel = getPostTypeLabel(post);
  const imageUrl = post.image?.small || post.image?.original;
  const author = post.author || {};
  const isFeaturedContributor = Boolean(author.isFeaturedContributor);

  return (
    <PublicBlogCardRoot>
      <PublicBlogCardGrid>
        <PublicBlogCardMedia>
          {imageUrl && <img src={imageUrl} alt="" loading="lazy" />}
          <PublicBlogCardMediaGradient aria-hidden="true" />
          <PublicBlogTypePill>
            <span className="material-icons" aria-hidden="true">
              {typeIcon(typeLabel)}
            </span>
            {typeLabel}
          </PublicBlogTypePill>
        </PublicBlogCardMedia>

        <PublicBlogCardBody>
          <PublicBlogAuthorRow>
            <PublicBlogAuthorLink
              to={`/analyst/${author.slug}`}
              onClick={(event) => event.stopPropagation()}
            >
              <img src={getPublisherAvatarUrl(author)} alt="" loading="lazy" />
              <div>
                <strong>{author.name}</strong>
                {author.title && <span>{author.title}</span>}
                {isFeaturedContributor && (
                  <FeaturedContributorBadge>
                    Featured Contributor
                  </FeaturedContributorBadge>
                )}
              </div>
            </PublicBlogAuthorLink>
          </PublicBlogAuthorRow>

          <PublicBlogCardTitle>{post.title}</PublicBlogCardTitle>
          <PublicBlogCardExcerpt>
            {getPlainExcerpt(post.excerpt)}
          </PublicBlogCardExcerpt>

          {!!post.tags?.length && (
            <PublicBlogTags>
              {post.tags.slice(0, 4).map((tag) => (
                <PublicBlogTag key={tag.id || tag.name}>
                  #{tag.name}
                </PublicBlogTag>
              ))}
            </PublicBlogTags>
          )}

          <PublicBlogMeta>
            <PublicBlogMetaDate>
              <span className="material-icons" aria-hidden="true">
                event
              </span>
              {formatPostDate(post.publishedAt)}
            </PublicBlogMetaDate>
          </PublicBlogMeta>
        </PublicBlogCardBody>
      </PublicBlogCardGrid>

      <PublicBlogCardOverlayLink to={post.url}>
        <span>Read {post.title}</span>
      </PublicBlogCardOverlayLink>
    </PublicBlogCardRoot>
  );
};

export default PublicBlogCard;
